import { default as DatepickerInput } from './DatepickerInput.component'
export default DatepickerInput
